import React, { useEffect, useState } from 'react'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import Empty from '../../controls/Empty'
import {
  MdErrorOutline,
  MdOutlineTag,
  MdOutlineCalendarMonth,
  MdOutlinePhone,
  MdOutlineHome,
  MdOutlineMonitorWeight,
  MdOutlineStickyNote2,
  MdOutlineComment,
} from 'react-icons/md'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import Paging from '../../controls/Paging'
import { PAGE_SIZE } from '../../../configurations/initUrls';
import StatusContainer from '../../controls/StatusContainer';
import { Link, useParams } from 'react-router-dom';
import Input from '../../controls/Input';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { IoMdOpen } from 'react-icons/io';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { GetEGenderName } from '../../../configurations/enums/EGender'
import moment from 'moment'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import Select from '../../controls/Select'
import { FaClinicMedical } from 'react-icons/fa'
import { GetAllByUser } from "../../../configurations/crud/opdCentersCrud"

export default function GetTodaysEmergency() {
  const { userid } = useParams()
  const initValues = {
    UserId: userid,
    CenterId: "",
    PageNo: 1,
    PageSize: PAGE_SIZE,
    SearchTerm: "",
  }
  const { start, end } = useGlobalLoader()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

  useEffect(() => {
    setSearchDebounce(searchTerm)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  useEffect(() => {
    onSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDebounce])


  const OnPageChange = (e) => {
    setSearch({ ...search, PageNo: e })
    onSearchNew({
      UserId: search.UserId,
      CenterId: search.CenterId,
      PageNo: e,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }
  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }
  const onSearch = () => {
    if (searchTerm) {
      setSearch({ ...search, CenterId: searchTerm })
      onSearchNew({
        UserId: search.UserId,
        CenterId: searchTerm,
        PageNo: 1,
        PageSize: search.PageSize,
        SearchTerm: ""
      })
    }
  }
  const onSearchNew = (search) => {
    GetTodaysEmergency(search)
  }

  const doRefresh = () => {
    setSearch({ ...search, PageNo: 1 })
    onSearchNew({
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }

  const GetTodaysEmergency = (params) => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetTodaysEmergency(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }
  const [opdCenters, setOpdCenter] = useState([]);
  useEffect(() => {
    getAllOpdCenters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetAllByUser()
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter([]);
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter([]);
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  // three badges: status / source / type
  const renderBadges = (item) => (
    <div className="whitespace-nowrap flex items-center gap-1">
      <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
      <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
      <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
    </div>
  )

  return (
    <div className="flex flex-col">
      {/* center filter */}
      <div className="py-3">
        <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-gray-700">
          <FaClinicMedical className="text-sm text-red-600" /> Select Center
        </label>
        <Select
          Icon={<FaClinicMedical className="text-lg text-red-600" />}
          value={searchTerm}
          onChange={onSearchChange}
        >
          <option value="">Select Center...</option>
          {opdCenters.map(item => (
            <option key={item.id} value={item.id}>{item.centerName}</option>
          ))}
        </Select>
      </div>

      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData}>
        {!loding ? (
          userData.length > 0 ? (
            <>
              {/* ===== desktop table ===== */}
              <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 lg:block">
                <table className="w-full border-collapse text-left text-sm text-gray-500 rtl:text-right">
                  <thead>
                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><FaClinicMedical className="text-xs" /> Center</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> #</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">Patient</th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlinePhone className="text-sm" /> Phone</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineMonitorWeight className="text-sm" /> Weight</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineStickyNote2 className="text-sm" /> Note</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineComment className="text-sm" /> Comment</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineCalendarMonth className="text-sm" /> Date</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineHome className="text-sm" /> Address</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">Badges</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {userData.map((item, index) => (
                      <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                        <td className="text-nowrap px-3 py-2">{item.opdCenter.centerName}</td>
                        <td className="px-3 py-2 text-gray-500">{item.id}</td>
                        <td className="text-nowrap px-3 py-2 font-bold text-gray-800">
                          {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                        </td>
                        <td className="text-nowrap px-3 py-2">
                          {item.mobile
                            ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                            : "—"}
                        </td>
                        <td className="text-nowrap px-3 py-2">{item.weight}</td>
                        <td className="max-w-[120px] truncate px-3 py-2" title={item.note}>{item.note ? item.note : "N/A"}</td>
                        <td className="max-w-[120px] truncate px-3 py-2" title={item.acceptedWithComment}>{item.acceptedWithComment ? item.acceptedWithComment : "N/A"}</td>
                        <td className="text-nowrap px-3 py-2">{moment(item.onDate).format("DD/MMM/YYYY")}</td>
                        <td className="max-w-[140px] truncate px-3 py-2" title={item.patientAddress}>{item.patientAddress}</td>
                        <td className="whitespace-nowrap px-3 py-2">{renderBadges(item)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ===== mobile / tablet cards ===== */}
              <div className="space-y-2 lg:hidden">
                {userData.map((item, index) => (
                  <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <div className="font-bold text-gray-900">
                          {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                        </div>
                        <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500">
                          <span className="flex items-center gap-0.5"><MdOutlineTag className="text-sm" /> {item.id}</span>
                          <span className="flex items-center gap-0.5"><MdOutlineMonitorWeight className="text-sm" /> {item.weight} Kg</span>
                        </div>
                        <div className="mt-0.5 flex items-center gap-1 text-xs text-gray-500">
                          <FaClinicMedical className="shrink-0 text-[10px]" />
                          <span className="truncate">{item.opdCenter.centerName}</span>
                        </div>
                      </div>
                      <span className="flex shrink-0 items-center gap-1 text-xs text-gray-400">
                        <MdOutlineCalendarMonth className="text-sm" />
                        {moment(item.onDate).format("DD/MMM/YYYY")}
                      </span>
                    </div>

                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                      <div className="flex items-center gap-1">
                        <MdOutlinePhone className="shrink-0 text-sm text-gray-400" />
                        {item.mobile
                          ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                          : "—"}
                      </div>
                      <div className="flex items-start gap-1">
                        <MdOutlineHome className="mt-0.5 shrink-0 text-sm text-gray-400" />
                        <span>{item.patientAddress}</span>
                      </div>
                      {item.note &&
                        <div className="flex items-start gap-1">
                          <MdOutlineStickyNote2 className="mt-0.5 shrink-0 text-sm text-gray-400" />
                          <span>{item.note}</span>
                        </div>}
                      {item.acceptedWithComment &&
                        <div className="flex items-start gap-1">
                          <MdOutlineComment className="mt-0.5 shrink-0 text-sm text-gray-400" />
                          <span>{item.acceptedWithComment}</span>
                        </div>}
                    </div>

                    <div className="mt-2">{renderBadges(item)}</div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Empty>No Items Found.</Empty>
          )
        ) : (
          <LoadingContainer />
        )}
      </Paging>
    </div>
  )
}